import {
  EMPTY_RESULT_PLACEHOLDER,
  EMPTY_RESULT_PLACEHOLDER_WITH_NETWORK_ERROR,
} from "../../Editor/Document/DocumentOutput/DocumentResults/DocumentResults";
import {
  CANCEL_RESULT_PLACEHOLDER,
  CANCEL_RESULT_PLACEHOLDER_WITH_NETWORK_ERROR,
} from "../../contexts/DocumentsContext/constants";
import { QueryStatementStatus } from "../../workspace.types";

export const getResultPlaceholderByStatus = (
  status: QueryStatementStatus,
  hadNetworkError: boolean
) => {
  if (status === QueryStatementStatus.cancelled) {
    return hadNetworkError
      ? CANCEL_RESULT_PLACEHOLDER_WITH_NETWORK_ERROR
      : CANCEL_RESULT_PLACEHOLDER;
  }
  if (status === QueryStatementStatus.success) {
    return hadNetworkError
      ? EMPTY_RESULT_PLACEHOLDER_WITH_NETWORK_ERROR
      : EMPTY_RESULT_PLACEHOLDER;
  }
  return undefined;
};
